<template>
  <div>
    <div style="margin-bottom: 24px;">
      <div class="title hide-on-small-only">
        <h4>Questionários</h4>

        <div style="display: flex;">
          <a
            class="waves-effect waves-light btn"
            style="margin-right: 16px;"
            @click="openFilter = true"
          >
            <i class="material-icons">filter_alt</i>
          </a>
          <router-link
            tag="a"
            v-show="checkModulePermission('quiz', 'create')"
            class="waves-effect waves-light btn"
            :to="{ name: 'quiz-create' }"
          >
            <i class="material-icons">add</i>
          </router-link>
        </div>
      </div>

      <a
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        style="bottom: 88px;"
        @click="openFilter = true"
      >
        <i class="material-icons">filter_alt</i>
      </a>
      <router-link
        tag="a"
        v-show="checkModulePermission('quiz', 'create')"
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        :to="{ name: 'quiz-create' }"
      >
        <i class="material-icons">add</i>
      </router-link>

      <!-- Content -->

      <div class="hide-on-small-only">
        <table class="table">
          <thead>
            <th width="40%">Título</th>
            <th width="40%">Cliente</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-if="!quizzes.data.length > 0">
              <td colspan="6" class="center-align">
                {{
                  loadItens
                    ? "Buscando Questionários..."
                    : "Nenhum Questionário cadastrada"
                }}
              </td>
            </tr>
            <tr v-else v-for="quiz in quizzes.data" :key="quiz.uuid">
              <td>{{ quiz.name }}</td>
              <td>{{ quiz.customer.company_name }}</td>
              <td class="table__actions">
                <template v-if="isAdmin()">
                  <a
                    href="#"
                    @click.prevent="() => handleRedirectGeneratePdf(quiz.uuid)"
                    class="waves-effect waves-light btn btn-icon"
                  >
                    <i class="material-icons">picture_as_pdf</i>
                  </a>
                  <router-link
                    class="waves-effect waves-light btn btn-icon"
                    tag="a"
                    :to="{ name: 'mobile-report', params: { uuid: quiz.uuid } }"
                  >
                    <i class="material-icons">phone_iphone</i>
                  </router-link>
                </template>

                <template
                  v-if="checkModulePermission('quiz', 'apply') && quiz.active"
                >
                  <a
                    href="#"
                    @click.prevent="sendQuiz(quiz.uuid)"
                    class="waves-effect waves-light btn btn-icon"
                  >
                    <i class="material-icons">send</i>
                  </a>
                </template>

                <template v-if="checkModulePermission('quiz', 'edit')">
                  <router-link
                    class="waves-effect waves-light btn btn-icon"
                    tag="a"
                    :to="{ name: 'quiz-edit', params: { id: quiz.uuid } }"
                  >
                    <i class="material-icons">edit</i>
                  </router-link>
                  <disabled-item-button
                    :id="quiz.uuid"
                    @click="disabled(quiz.uuid, quiz.active == 1)"
                    :active="!!quiz.active"
                  />
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          v-if="quizzes.data"
          :total-pages="totalPages"
          @changePage="changePage"
          :current-page="currentPage"
        />
      </div>

      <div class="box-list hide-on-med-and-up">
        <ul class="collection">
          <li v-if="!quizzes.data.length > 0" class="white default-item">
            <p>
              {{
                loadItens
                  ? "Buscando Questionários..."
                  : "Nenhum questioário cadastrado"
              }}
            </p>
          </li>
          <li
            v-else
            class="collection-item avatar"
            v-for="quiz in quizzes.data"
            :key="quiz.uuid"
          >
            <div class="collection-item__text">
              <span class="title">{{ quiz.name }}</span>
              <p>
                <b>Tipo de Resposta:</b>
                <br />
                {{ quiz.customer.company_name }}
              </p>
            </div>
            <div class="collection-item__actions">
              <template v-if="isAdmin()">
                <a
                  href="#"
                  @click.prevent="() => handleRedirectGeneratePdf(quiz.uuid)"
                  class="waves-effect waves-light btn btn-icon hide-on-small-only"
                >
                  <i class="material-icons">picture_as_pdf</i>
                </a>
                <router-link
                  class="waves-effect waves-light btn btn-icon hide-on-small-only"
                  tag="a"
                  :to="{ name: 'mobile-report', params: { uuid: quiz.uuid } }"
                >
                  <i class="material-icons">phone_iphone</i>
                </router-link>
              </template>

              <template
                v-if="checkModulePermission('quiz', 'apply') && quiz.active"
              >
                <a
                  href="#"
                  @click.prevent="sendQuiz(quiz.uuid)"
                  class="waves-effect waves-light btn btn-icon"
                >
                  <i class="material-icons">send</i>
                </a>
              </template>

              <template v-if="checkModulePermission('quiz', 'edit')">
                <router-link
                  class="waves-effect waves-light btn btn-icon"
                  tag="a"
                  :to="{ name: 'quiz-edit', params: { id: quiz.uuid } }"
                >
                  <i class="material-icons">edit</i>
                </router-link>
                <disabled-item-button
                  :id="quiz.uuid"
                  @click="disabled(quiz.uuid, quiz.active == 1)"
                  :active="!!quiz.active"
                  class="disabled-button"
                />
              </template>
            </div>
          </li>
          <li
            v-if="totalPages > 0 && currentPage !== totalPages"
            @click="changePage(currentPage + 1)"
            class="white default-item get-itens"
          >
            <feather v-if="loadItens" type="loader" animation="spin" />
            <p v-else>Buscar mais itens</p>
          </li>
        </ul>
      </div>
    </div>

    <VSideSlider
      :open="openFilter"
      @close="openFilter = false"
      title="Filtro de Questões"
    >
      <div slot="body">
        <div class="row">
          <div class="input-field col s12">
            <label for="name">Titulo do questionário</label>
            <input type="text" name="name" id="name" v-model="filter.name" />
          </div>
          <div class="input-field col s12">
            <select v-model="filter.customer.uuid">
              <option value disabled selected>Selecione o cliente</option>
              <option
                class="left"
                v-for="customer in customers"
                :value="customer.uuid"
                :key="customer.uuid"
                >{{ customer.company_name }}</option
              >
            </select>
          </div>
        </div>
      </div>
      <div slot="actions">
        <div class="row">
          <div class="col s12 m6 s-mb-16">
            <button
              class="waves-effect btn-large flat form-button"
              @click="clearFilter"
            >
              Limpar
            </button>
          </div>
          <div class="col s12 m6">
            <button
              class="waves-effect waves-light btn-large form-button"
              @click="handlesFilter"
              :class="{ load: loadFilter }"
            >
              <feather v-if="loadFilter" type="loader" animation="spin" />
              <template v-else>Filtrar</template>
            </button>
          </div>
        </div>
      </div>
    </VSideSlider>
  </div>
</template>

<script>
import { mapState } from "vuex";
import checkModulePermission from "@/services/mixins/checkModulePermission";

export default {
  name: "QuizList",
  mixins: [checkModulePermission],
  components: {
    VSideSlider: () => import("@/components/VSideSlider")
  },
  data: () => ({
    loadItens: false,
    openFilter: false,
    loadFilter: false,
    instanceSelect: {},
    customers: [],
    filter: {
      name: "",
      customer: {
        uuid: ""
      }
    },
    currentPage: 1,
    totalPages: 0,
    quizzes: {
      data: []
    }
  }),
  async mounted() {
    await this.getQuizzes();
    await this.getCustomers();
  },
  computed: {
    ...mapState("User", ["token"])
  },
  watch: {
    openFilter(value) {
      if (value) {
        const el = this.$el.querySelectorAll("select");
        M.FormSelect.init(el);
      }
    }
  },
  methods: {
    handleRedirectGeneratePdf(uuid) {
      let routeData = this.$router.resolve({
        name: "generate-pdf-quiz",
        params: { uuid }
      });

      window.open(routeData.href, "_blank");
    },
    clearFilter() {
      this.filter.name = "";

      this.$el.querySelector(`label[for=name]`).classList.remove("active");

      this.filter.customer.uuid = "";

      this.openFilter = false;

      this.getQuizzes(1);
    },
    async handlesFilter() {
      this.loadFilter = true;

      let query = "&search=";

      if (this.filter.name != "") query += `name:${this.filter.name}`;
      if (this.filter.customer.uuid != "")
        query += `customer.uuid:${this.filter.customer.uuid}`;

      if (query != "&search=")
        await this.getQuizzes(
          1,
          query.includes(";") ? query.substring(0, query.length - 1) : query
        );
      this.loadFilter = false;
      this.openFilter = false;
    },
    async getCustomers(query) {
      let url = "customers";

      if (query) url += `?search=${query}`;

      try {
        const response = await this.$http.get(url, {
          headers: {
            Authorization: this.token
          }
        });

        const { customers } = response.body.data;
        this.customers = customers;
      } catch (e) {
        console.error(e);
      }
    },
    async getQuizzes(page, query = "") {
      const pageSearch = page || this.currentPage;

      let url = `quizzes?page=${pageSearch}` + query;

      try {
        this.loadItens = true;
        const response = await this.$http.get(url, {
          headers: {
            Authorization: this.token
          }
        });
        this.loadItens = false;
        const { quizzes } = response.body.data;
        this.quizzes = quizzes;
        this.totalPages = quizzes.meta.total;
      } catch (e) {
        console.error(e);
      }
    },
    async changePage(payload) {
      await this.getQuizzes(payload);
      this.currentPage = payload;
    },
    sendQuiz(id) {
      this.$swal({
        title: "Deseja ir para esse questionário?",
        icon: "warning",
        buttons: {
          onCancel: {
            text: "Cancelar",
            value: false,
            className: "waves-effect btn-large flat"
          },
          confirm: {
            text: "Continuar",
            value: true,
            className: "waves-effect waves-light btn-large"
          }
        }
      }).then(val => {
        if (val) {
          this.$router.push({ name: "response-quiz", params: { id } });
        }
      });
    },
    disabled(id, active) {
      this.$swal({
        title: "Tem certeza?",
        text: "Este item será desabilitado.",
        icon: "warning",
        buttons: {
          back: {
            text: "Cancelar"
          },
          confirm: {
            text: "Continuar",
            value: "ACTION",
            closeModal: false
          }
        }
      })
        .then(async v => {
          if (v === "ACTION") {
            try {
              await this.$http.post(
                `quizzes/${id}`,
                {
                  quiz: {
                    active: active ? 0 : 1
                  }
                },
                {
                  headers: {
                    Authorization: `bearer ${this.token}`
                  }
                }
              );
              const el = document.getElementById(id);

              this.quizzes.data = this.quizzes.data.map(val => {
                if (val.uuid === id) {
                  return {
                    ...val,
                    active: active ? 0 : 1
                  };
                }

                return val;
              });

              if (active) el.classList.remove("active");
              else el.classList.add("active");

              this.$swal.stopLoading();
              this.$swal.close();
            } catch (e) {
              throw e;
            }
          }

          return null;
        })
        .catch(err => {
          if (err) {
            this.$swal(
              "Opss..",
              "Falha ao se comunicar com servidor, tente novamente mais tarde",
              "error"
            );
          } else {
            this.$swal.stopLoading();
            this.$swal.close();
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.form-button {
  width: 100%;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  @media #{$small-and-down} {
    padding: 16px 24px;
    a {
      height: 100%;
      width: 100%;
    }
  }
}
.box-list {
  padding: 0 16px;
}
.circle {
  top: 50%;
  transform: translateY(-50%);
}
@media #{$small-and-down} {
  .collection-item {
    .title {
      padding: 10px 0 !important;
    }
  }
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 48px;
  }
}
.default-item {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
